import React from 'react'
import { Draggable } from 'react-drag-reorder'
import { Box, Typography } from '@mui/material'

const DFYDraggableList = ({ extraDomains, handlePosChange }) => {
   
    return (
        <Draggable key={extraDomains.map(s=>s.domain).join(',')} onPosChange={handlePosChange}>
            {extraDomains.map((suggestion, index) => {
                return (
                    <Box
                        key={index}
                        variant='outlined'
                        className="flex-item"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid rgba(224, 224, 229, 1)',
                            borderRadius: 1,
                            backgroundColor: '#ffffff',
                            color: '#111927',
                            p: 1,
                            mx: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 500,
                                textDecoration: !suggestion.isAvailable ? 'line-through' : 'none',
                                color: !suggestion.isAvailable ? '#5B5B5B' : '#111927'
                            }}
                        >
                            {' '}
                            {suggestion.domain}
                        </Typography>
                    </Box>
                )
            })}
        </Draggable>
    )
}

export default DFYDraggableList